import http from '../../http'

// 获取任务列表
let getTaskList = (params) => {
   return http.get('opservice/taskjob/page', params)
}
// 开始任务
let startTask = (data) => {
  return http.post('opservice/taskjob/start', data)
}
// 停止任务
let stopTask = (data) => {
  return http.post('opservice/taskjob/stop', data)
}
// 删除任务
let deleteTask = (data) => {
  return http.post('opservice/taskjob/delete', data)
}
// 获取短信统计信息
let smsReport = (params) => {
  return http.get('opservice/taskjob/msgQueueCount', params)
}
// 获取短信统计列表
let smsReportList = (params) => {
  return http.get('opservice/taskjob/msgQueue', params)
}
// 保存或修改自动化任务
let saveTaskJob = (data) => {
  return http.post('opservice/taskjob/save', data)
}
// 获取任务的详情
let getTaskDetailInfo = (params) => {
  return http.get('opservice/taskjob/info', params)
}
// 获取文章列表
let getArticleList = (params) => {
  return http.get('content-service/cnt_article/page', params)
}

export default {
  getTaskList,
  startTask,
  stopTask,
  deleteTask,
  smsReport,
  smsReportList,
  saveTaskJob,
  getTaskDetailInfo,
  getArticleList
}